import { useNavigate } from "react-router-dom";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useSiteLang as useLang } from '../siteLang';
import '../design-system.css';
import React, { useEffect } from 'react';

const content = {
    fr: {
        eyebrow: 'Légal',
        title: 'Aide & informations',
        subtitle: 'Informations légales et contact pour winston.ie.',
        sections: [
            ['Propriété & droits d\'auteur', 'winston.ie est un label de photographie curée, faisant partie de l\'écosystème Longden Collective — un studio créatif réunissant plusieurs labels indépendants sous un même nom. throughmyeyes et Ardoise sont des labels distincts au sein du même écosystème, chacun avec sa propre identité et son contenu. Tout le contenu publié sous winston.ie — photos, albums, textes et concepts — est original et non commercial. La reproduction, redistribution ou modification non autorisée n\'est pas permise sans consentement préalable.'],
            ['Nature du projet', 'Ce site est un projet de photographie curée, non commercial. Aucun produit, service ou transaction financière n\'est offert. Tout le contenu est partagé à des fins créatives, archivistiques et expérimentales uniquement.'],
            ['Marques & dénomination', 'Le nom winston.ie est utilisé comme label créatif et identifiant au sein de l\'écosystème Longden Collective. Il ne représente pas une entreprise, corporation ou entité légale enregistrée à ce jour — winston.ie et Longden Collective ne sont pas des entités légalement incorporées.'],
        ],
        lastUpdate: 'DERNIÈRE MISE À JOUR : 28 JUILLET 2026',
        contactEyebrow: 'Nous joindre',
        contactTitle: 'Une question ?',
        contactBody: 'Pour toute question liée au contenu, aux droits d\'usage, à l\'auteur, ou tout autre commentaire, contacte-nous.',
        contactBtn: 'Aller au formulaire de contact',
        contactEmail: 'Ou écris directement à',
        privacyLink: 'Voir la politique de confidentialité →',
        back: '← Retour',
    },
    en: {
        eyebrow: 'Legal',
        title: 'Help & information',
        subtitle: 'Legal information and contact for winston.ie.',
        sections: [
            ['Ownership & copyright', 'winston.ie is a curated photography label, part of the Longden Collective ecosystem — a creative studio bringing together several independent labels under one name. throughmyeyes and Ardoise are separate labels within the same ecosystem, each with its own identity and content. All content published under winston.ie — photos, albums, texts, and concepts — is original and non-commercial. Unauthorized reproduction, redistribution, or modification is not permitted without prior consent.'],
            ['Nature of the project', 'This website is a non-commercial, curated photography project. No products, services, or financial transactions are offered. All content is shared for creative, archival, and experimental purposes only.'],
            ['Trademarks & naming', 'The name winston.ie is used as a creative label and identifier within the Longden Collective ecosystem. It does not represent a registered company, corporation, or legal entity — winston.ie and Longden Collective are not legally incorporated entities at this time.'],
        ],
        lastUpdate: 'LAST UPDATE: JULY 28, 2026',
        contactEyebrow: 'Get in touch',
        contactTitle: 'Have a question?',
        contactBody: 'For inquiries related to content, usage permissions, authorship, or feedback, reach out.',
        contactBtn: 'Go to the contact form',
        contactEmail: 'Or write directly to',
        privacyLink: 'View the privacy policy →',
        back: '← Back',
    },
    vi: {
        eyebrow: 'Pháp lý',
        title: 'Trợ giúp & thông tin',
        subtitle: 'Thông tin pháp lý và liên hệ cho winston.ie.',
        sections: [
            ['Quyền sở hữu & bản quyền', 'winston.ie là một nhãn hiệu nhiếp ảnh được tuyển chọn, thuộc hệ sinh thái Longden Collective — một studio sáng tạo tập hợp nhiều nhãn hiệu độc lập dưới một tên gọi. throughmyeyes và Ardoise là các nhãn hiệu riêng biệt trong cùng hệ sinh thái, mỗi nhãn có bản sắc và nội dung riêng. Tất cả nội dung đăng trên winston.ie — ảnh, album, văn bản và ý tưởng — đều là bản gốc và phi thương mại. Không được sao chép, phân phối lại hoặc chỉnh sửa mà không có sự đồng ý trước.'],
            ['Bản chất của dự án', 'Trang web này là một dự án nhiếp ảnh được tuyển chọn, phi thương mại. Không có sản phẩm, dịch vụ hoặc giao dịch tài chính nào được cung cấp. Tất cả nội dung được chia sẻ chỉ nhằm mục đích sáng tạo, lưu trữ và thử nghiệm.'],
            ['Thương hiệu & tên gọi', 'Tên winston.ie được sử dụng như một nhãn hiệu sáng tạo và định danh trong hệ sinh thái Longden Collective. Nó không đại diện cho một công ty, tập đoàn hoặc thực thể pháp lý đã đăng ký — winston.ie và Longden Collective hiện chưa phải là các thực thể pháp lý được đăng ký.'],
        ],
        lastUpdate: 'CẬP NHẬT LẦN CUỐI: 28 THÁNG 7, 2026',
        contactEyebrow: 'Liên hệ',
        contactTitle: 'Bạn có câu hỏi?',
        contactBody: 'Để biết thêm về nội dung, quyền sử dụng, tác giả, hoặc góp ý, hãy liên hệ với chúng tôi.',
        contactBtn: 'Đến biểu mẫu liên hệ',
        contactEmail: 'Hoặc viết trực tiếp tới',
        privacyLink: 'Xem chính sách bảo mật →',
        back: '← Quay lại',
    },
};

function Help() {
    const navigate = useNavigate();
    const { lang } = useLang();
    const c = content[lang] || content.fr;

    useEffect(() => { document.title = 'Help | winston.ie'; }, []);

    return (
        <div className="w-page">
            <Navbar variant="light" />

            <div className="w-body" style={{ maxWidth: '640px' }}>
                <p className="w-eyebrow" style={{ cursor: 'pointer' }} onClick={() => navigate(-1)}>{c.back}</p>

                <p style={{ fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--w-muted)', marginBottom: '10px' }}>
                    {c.eyebrow}
                </p>
                <h1 className="w-title" style={{ marginBottom: '4px' }}>{c.title}</h1>
                <p className="w-subtitle" style={{ marginBottom: '48px' }}>{c.subtitle}</p>

                {c.sections.map(([heading, body], i) => (
                    <div key={i} style={{ borderTop: '1px solid var(--w-border)', paddingTop: '26px', marginBottom: '26px' }}>
                        <h3 style={{ fontSize: '13.5px', fontWeight: 600, letterSpacing: '0.01em', marginBottom: '10px', color: 'var(--w-ink)' }}>
                            {heading}
                        </h3>
                        <p style={{ fontSize: '14px', color: 'var(--w-ink-soft)', lineHeight: 1.8, margin: 0 }}>
                            {body}
                        </p>
                    </div>
                ))}

                <div style={{ borderTop: '1px solid var(--w-border)', paddingTop: '18px', marginBottom: '48px' }}>
                    <p style={{ fontSize: '10.5px', color: 'var(--w-muted)', letterSpacing: '0.03em' }}>{c.lastUpdate}</p>
                </div>

                <div style={{ borderTop: '1px solid var(--w-border)', paddingTop: '36px' }}>
                    <p style={{ fontSize: '11px', letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--w-muted)', marginBottom: '8px' }}>
                        {c.contactEyebrow}
                    </p>
                    <h3 style={{ fontSize: '17px', fontWeight: 600, color: 'var(--w-ink)', marginTop: 0, marginBottom: '14px' }}>
                        {c.contactTitle}
                    </h3>
                    <p style={{ fontSize: '13.5px', color: 'var(--w-ink-soft)', lineHeight: 1.7, marginBottom: '20px' }}>
                        {c.contactBody}
                    </p>

                    <button
                        className="wlink"
                        onClick={() => navigate('/contact')}
                        style={{ display: 'block', background: 'none', border: 'none', padding: 0, borderRadius: 0, fontWeight: 300, fontSize: '15px', color: 'var(--w-ink)', marginBottom: '20px' }}
                    >
                        {c.contactBtn}
                    </button>

                    <p style={{ fontSize: '12.5px', color: 'var(--w-muted)' }}>
                        {c.contactEmail}{' '}
                        <a href="mailto:contact@winston.longden.site" className="wlink" style={{ color: 'var(--w-accent)' }}>contact@winston.longden.site</a>
                    </p>

                    <p
                        onClick={() => navigate('/privacy')}
                        className="wlink"
                        style={{ display: 'inline-block', fontSize: '12.5px', color: 'var(--w-accent)', marginTop: '20px' }}
                    >
                        {c.privacyLink}
                    </p>
                </div>
            </div>

            <Footer variant="light" />
        </div>
    );
}

export default Help;